import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useState } from "react";
import { getCutOffTime } from "redux/actions/cutOffTimeAction";
import { CUTOFF_ACTION, PRODUCT_TYPE } from "./CONSTANTS";

export default function CutOffTimeAlert(actionType) {
  const dispatch = useDispatch();
  const [marqueeMessage, setMarqueeMessage] = useState(null);
  const { cutOffTimeResponse } = useSelector((state) => state.cutOffTime);
  const [transformedData, setTransformedData] = useState([]);

  useEffect(() => {
    dispatch(getCutOffTime());
  }, [dispatch]);

  useEffect(() => {
    if (cutOffTimeResponse?.manualOrderConfigParams) {
      const transformed = cutOffTimeResponse.manualOrderConfigParams.map(
        (item) => ({
          ...item,
          producttype: item.producttype,
        })
      );
      setTransformedData(transformed);
    }
  }, [cutOffTimeResponse]);

  useEffect(() => {
    const showMarquee = () => {
      const now = dayjs();

      const ambientFrozenNightData = [];
      const freshDayData = [];
      const tobaccoData = [];
      const derivedData = [];

      transformedData.forEach((item) => {
        if (item.action === actionType.actionType) {
          const [hours, minutes] = item.cutoff
            .split(":")
            .map((num) => parseInt(num));

          if (!isNaN(hours) && !isNaN(minutes)) {
            const cutoffDate = dayjs()
              .set("hour", hours)
              .set("minute", minutes)
              .set("second", 0)
              .set("millisecond", 0);
            const displayStartTime = cutoffDate.subtract(1, "hour");

            if (now.isBetween(displayStartTime, cutoffDate, null, "[]")) {
              const existingDataIndex = derivedData.findIndex(
                (data) => data.action === item.action
              );
              let newItem = {
                ...item,
                productTypeToDisplay: [PRODUCT_TYPE[item.producttype[0]]],
              };

              if (existingDataIndex >= 0) {
                newItem = derivedData[existingDataIndex];
              }

              if (newItem.cutoff !== item.cutoff) {
                const [newHours, newMinutes] = newItem.cutoff
                  .split(":")
                  .map((num) => parseInt(num));
                const [itemHours, itemMinutes] = item.cutoff
                  .split(":")
                  .map((num) => parseInt(num));

                if (
                  itemHours - newHours > 0 ||
                  (itemHours - newHours === 0 && itemMinutes - newMinutes > 0)
                ) {
                  newItem.cutoff = item.cutoff;
                }
              }

              if (existingDataIndex >= 0) {
                newItem.producttype = [
                  ...newItem.producttype,
                  ...item.producttype,
                ];
                newItem.productTypeToDisplay = [
                  ...newItem.productTypeToDisplay,
                  PRODUCT_TYPE[item.producttype[0]],
                ];
              } else {
                derivedData.push(newItem);
              }

              const productType = PRODUCT_TYPE[item.producttype[0]];
              if (productType === PRODUCT_TYPE.Fresh_Day_Pick_Item) {
                freshDayData.push(newItem);
              } else if (productType === PRODUCT_TYPE.Tobacco) {
                tobaccoData.push(newItem);
              } else {
                ambientFrozenNightData.push(newItem);
              }
            }
          }
        }
      });

      const createMessage = (dataArray, daySubString) => {
        if (dataArray.length === 0) return "";

        const item = dataArray[0];

        const actionSubString =
          item.action === CUTOFF_ACTION.create_manual_order
            ? actionType.operationType === "store"
              ? "raised/amended/cancelled"
              : "raised"
            : item.action === CUTOFF_ACTION.amend_delete_manual_order
            ? "amended/cancelled"
            : "approved";

        const doActionSubString =
          item.action === CUTOFF_ACTION.create_manual_order
            ? actionType.operationType === "store"
              ? "raise/amend/cancel"
              : "raise"
            : item.action === CUTOFF_ACTION.amend_delete_manual_order
            ? "amend/cancel"
            : "approve";

        const productTypes = item.productTypeToDisplay.join("/");
        return `Please note that ${productTypes} manual orders ${actionSubString} for ${daySubString} order date after ${item.cutoff} will not be processed by the system. Please ${doActionSubString} orders on or before this time.`;
      };

      const ambientFrozenNightMessage = createMessage(
        ambientFrozenNightData.filter((d) =>
          d.productTypeToDisplay.some(
            (p) =>
              p === PRODUCT_TYPE.Ambient ||
              p === PRODUCT_TYPE.Frozen ||
              p === PRODUCT_TYPE.Fresh_Night_Pick_Item
          )
        ),
        "today's"
      );

      const freshDayMessage = createMessage(
        freshDayData.filter((d) =>
          d.productTypeToDisplay.includes(PRODUCT_TYPE.Fresh_Day_Pick_Item)
        ),
        "tomorrow's"
      );

      const tobaccoMessage = createMessage(
        tobaccoData.filter((d) =>
          d.productTypeToDisplay.includes(PRODUCT_TYPE.Tobacco)
        ),
        "today's"
      );

      let combinedMessage = "";
      if (ambientFrozenNightMessage)
        combinedMessage += ambientFrozenNightMessage;
      if (freshDayMessage) combinedMessage += freshDayMessage;
      if (tobaccoMessage) combinedMessage += tobaccoMessage;

      if (combinedMessage) {
        setMarqueeMessage(combinedMessage);
      }
    };

    if (transformedData.length > 0) {
      showMarquee();
    }

    const interval = setInterval(() => {
      if (transformedData.length > 0) {
        showMarquee();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [setMarqueeMessage, transformedData, actionType]);

  return (
    <>
      {/* Display the marquee message if available */}
      {marqueeMessage && (
        <div className="marqueeDisplay">
          <Typography>{marqueeMessage}</Typography>
        </div>
      )}
    </>
  );
}
